export default {
  router: {
    56: '0x0ad5C283131fec3f3DdE4FA958048858e382eAFF',
    97: '0xe393380A92db9AC698A2ebaE3d2f8963268a16E2',
    1337: '0x568D9ABB2d0528FC394de816704bf9154ADE0100',
    9999: '0x30A8471D03a5B7B7B20eC431444CF8B032AF1071',
  },
  lottery: {
    56: '0x62ec4B3eFEA171e9D9bD15FE9027B2b12cc63053',
    97: '0x8FA6b31533F3D1d2636e27f5345AA0A8C49AEF60',
    1337: '0x8FA6b31533F3D1d2636e27f5345AA0A8C49AEF60',
    9999: '0x8FA6b31533F3D1d2636e27f5345AA0A8C49AEF60',
  },
  lotteryNFT: {
    56: '0xff0997392A63Ca7e5eaB82F22077eF848cb468e2',
    97: '0xf102eCc49bA92265137c1805C089b454d07167A2',
    1337: '0xf102eCc49bA92265137c1805C089b454d07167A2',
    9999: '0xf102eCc49bA92265137c1805C089b454d07167A2',
  },
  multiCall: {
    56: '0x41263cba59eb80dc200f3e2544eda4ed6a90e76c',
    97: '0xff0997392A63Ca7e5eaB82F22077eF848cb468e2',
    1337: '0x27D40F5Be7D466a1B3B73CbfbB7b544dE4aDa45F',
    9999: '0x9718D14CcCFAbE8b0ff89C41677a2A782ae90e96',
  },
  pixelFram: {
    56: '0x040270e09bf6F7e1554c85C48C6dcA223db9b008',
    97: '0x4229fE35B17e7Fdc16Ee4f65e4079B71466837A1',
    1337: '0x4229fE35B17e7Fdc16Ee4f65e4079B71466837A1',
    9999: '0x4229fE35B17e7Fdc16Ee4f65e4079B71466837A1',
  },
  presale: {
    56: '0xD1B4ae503Db70Cd584c936BAf6b415F585d2c219',
    97: '0x19B71900C5018415B45C7755a5C24e1740D0695b',
    1337: '0x19B71900C5018415B45C7755a5C24e1740D0695b',
    9999: '0x19B71900C5018415B45C7755a5C24e1740D0695b',
  },
  starter: {
    56: '',
    97: '0x0f4a308D47A2e2076761b45c236efd6711D3896C',
    1337: '0x0f4a308D47A2e2076761b45c236efd6711D3896C',
    9999: '0x0f4a308D47A2e2076761b45c236efd6711D3896C',
  },
  nft: {
    56: '0xa5976974d5A340Cc0a06aA41B3d8d4D6780F55Ba',
    97: '0x844C604f3B643D66Fe2014DfD1c9a44c822c32da',
    1337: '0xE21Cc0c69c69B964d57d6eF27bBcAcF2668451fD',
    9999: '0xf8F0B24C79cf72F8Dff0eD917763b74B98331D47',
  },
  exchange: {
    56: '0x6fb8eE4e23DDC8EE2D5FC2D5abEb4489dEb8951e',
    97: '0xEC14357956082De47b9e69790d7b61f2dbDD7eAE',
    1337: '0xEC14357956082De47b9e69790d7b61f2dbDD7eAE',
    9999: '0xEC14357956082De47b9e69790d7b61f2dbDD7eAE',
  },
  singlePool: {
    56: '0x202092336Ec4896e370065D226F83257f02E9Af3',
    97: '0x56d39571504A4F15D6431A6116A19Ab3c153469d',
    1337: '0x56d39571504A4F15D6431A6116A19Ab3c153469d',
    9999: '0x56d39571504A4F15D6431A6116A19Ab3c153469d',
  },
  fusionPool: {
    56: '0x7f0A823a4D75E0cC054fd377e72476e4dF7630d6',
    97: '0xc283a9587ddd80A28750BE4A8B0743410F4d26BC',
    1337: '0xc283a9587ddd80A28750BE4A8B0743410F4d26BC',
    9999: '0xc283a9587ddd80A28750BE4A8B0743410F4d26BC',
  },
  pxfToken: {
    56: '0x6a4792d10BEe30Ff25d1d8F9aA3721d204d88134',
    97: '0x69b4d8350eb2c379fd164cb14225296b67ebc214',
    1337: '0x811e3e6a7918e826aA6D8231b13b399A2c2CC4C8',
    9999: '0x2ccfA027275DFc1F9Ffd4Af675A65df59D8112F5',
  },
  airdrop: {
    56: '0x75732Bbf9B0B59A731352231D0dE319085B7207a',
    97: '',
    1337: '',
    9999: '',
  },
  limited: {
    56: '0x1a17284F3304e7e9f6de7df7807931573d077612',
    97: '0x361be0E80C12bC068E744C6905ac3d5ec03b715A',
    1337: '0xFB29b0e65DcE9D276eD48d56cb6B7EE8A43C124E',
    9999: '0xc2007BBDfEa68a549E4924b547c4983939154B20',
  },
  busdToken: {
    56: '0x6a4792d10BEe30Ff25d1d8F9aA3721d204d88134',
    97: '0xF1c9be9A08CDdA25E06AE0dAa0f47370bee52998',
    1337: '0x5FF651e4db84f9db985DDE650A80C2aAc2725D20',
    9999: '0xbfb8372a1Cd546d39e5e427061A65ff0Dd241C5E',
  },
  usdtToken: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '0xC0C0c4E4A1C2997265D067a73b0592cc84db411c',
    1337: '0xFf3C459c53C6151B16d8C7B89DD3A6749369bb85',
    9999: '0x63fD4a1Ae3A6f24a4e203c98c398325244Ef8CD8',
  },
  pxpToken: {
    56: '0x26aE4b6c3fD734EFAB7AA1A7eAF664009562399c',
    97: '0xC0C0c4E4A1C2997265D067a73b0592cc84db411c',
    1337: '0xaB66D0e0DD4CC56436f4ae3755da34262b7f5c24',
    9999: '0xEBF5FFe2Ff3E185633fF44E76bb8272d07785Ee9',
  },
  power: {
    56: '0x8440e573C6037dcB1195Ab783969A7aA27CC484E',
    97: '',
    1337: '0x7065662dC6B8598e95DC5d629C0a75ff7DEAb0f8',
    9999: '0x70A84C8096E93bEc36f3f1F82ff43b59aE67a225',
  },
  seller: {
    56: '0x657739a855Fb600deb99C3A46FC2edC3509799C1',
    97: '',
    1337: '0xC879Ad611e89cfe6E909Dd937168F7755102e882',
    9999: '0x4BC0349c6dC248CE956023724F2a37716010B9b4',
  },
  lendingPool: {
    56: '0xA8a68f14d7cF3feeC3eC01AcDF621439494eF554',
    97: '',
    1337: '0x4AAa2ef718472857399FE222e94cFAC28b7E0E18',
    9999: '0x59bCfB5F6531b222bE209aabE47c941634D95629',
  }
}
